import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GridList from '@material-ui/core/GridList';

import GridCustomTile from './GridCustomTile';

const thresholdNext = {
  md: 'lg',
  sm: 'md',
  xs: 'sm',
};

class MobileGridView extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    children: PropTypes.node,
    threshold: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    threshold: 'md',
  };

  render() {
    const { children, threshold } = this.props;
    const styles = {
      gridList: {
        display: 'flex',
        flexWrap: 'wrap',
        overflowY: 'auto',
        width: '100%',
      },
    };

    return (
      <div
        className={`d-${thresholdNext[threshold]}-up-none`}
        style={{ width: '100%' }}
      >
        <GridList
          cellHeight={220}
          cols={2}
          style={styles.gridList}
        >
          {children}
        </GridList>
      </div>
    );
  }
}

MobileGridView.GridCustomTile = GridCustomTile;

export default MobileGridView;
